<template>
    <div class="login-page">
        <div class="wrapper wrapper-full-page">
        <div class="full-page login-page section-image">
            <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
            <div class="content">
            <div class="container">
                <div class="col-lg-6 col-md-6 ml-auto mr-auto">
                <form>
                    <card type="login">
                    <h3 slot="header" class="header text-center">Establezca su contraseña</h3>
                    <p>Ingrese su nueva contraseña</p>
                    <!--Sending state-->
                    <loading :active.sync="isSending"
                    :can-cancel="false" 
                    :is-full-page="fullPage">
                    </loading>
                    <!--./Sending state-->
                    <fg-input ref="password"
                            v-model="model.password" 
                            addon-left-icon="nc-icon nc-key-25" 
                            placeholder="Contraseña"
                            name="contraseña"
                            autocomplete="off"
                            v-validate="modelValidations.password"
                            :error="getError('contraseña')"
                            type="password"></fg-input>
                    <fg-input v-model="model.confirmPassword"
                            addon-left-icon="nc-icon nc-key-25" 
                            placeholder="Confirme contraseña"
                            name="confirmar contraseña"
                            autocomplete="off"
                            v-validate="modelValidations.confirmPassword"
                            :error="getError('confirmar contraseña')"
                            type="password"></fg-input>
                    <br>
                    <div class="card-footer text-right">
                        <p-button  @click="cancelForm" class="pull-left" slot="footer" type="default" round >Cancelar</p-button>
                        <p-button native-type="submit" @click.prevent="validate"  type="warning" round>Continuar</p-button>
                    </div>
                    </card>
                </form>
                </div>
            </div>
            </div>
            <div class="full-page-background" v-bind:style="loginBackground()"></div>
        </div>
        </div>
    </div>
    </template>
    <script>
    import swal from 'sweetalert2'
    import { Card, Checkbox, Button } from 'src/components/UIComponents';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import SecureLS from 'secure-ls'
    import { SET_PASSWORD} from 'src/api/graphql/mutations/user/Reset';
    export default {
        components: {
        Card,
        Loading,
        [Checkbox.name]: Checkbox,
        [Button.name]: Button
        },
        methods: {
        cancelForm(){
        /*** 
        * Función que devuelve al formulario de login
        */
            this.$router.push('/login');
        },
        loginBackground(){
            return 'background-image: url('+process.env.VUE_APP_BASE_ROUTE+'img/login_background.jpg)';
        },
        toggleNavbar() {
            document.body.classList.toggle('nav-open')
        },
        closeMenu() {
            document.body.classList.remove('nav-open')
            document.body.classList.remove('off-canvas-sidebar')
        },
        getError (fieldName) {
        /*** 
        * Función que permite visualizar los errores en cada campo del input
        */
            return this.errors.first(fieldName)
        },
        /*** 
        * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro erróneo
        */
        onError(message){
            swal({
                title: `¡Alerta!`,
                text: message,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger btn-fill',
                type: 'error'
            });
        },
        /*** 
        * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro exitoso
        */
        onSuccess(){
            var vm = this;
            swal({
                title: '¡Correcto!',
                text: 'Tu contraseña ha sido cambiada satisfactoriamente',
                type: 'success',
                confirmButtonClass: 'btn btn-success btn-fill',
                buttonsStyling: false
            }).then(() => {
                vm.$router.push('/login');
            },function (dismiss){
                vm.$router.push('/login');
            });
        },
        /***
        * Función para decodificar el ID en base 64
        */
        idDecode(id){
            let id_decoded = atob(id);
            return id_decoded;
        },
        validate () {
        /***
        * Función para validar el formulario de edición y creación que se envía
        */
            this.$validator.validateAll().then(isValid => {
                if(isValid){
                    var vm = this;
                    vm.isSending = true;
                    var ruid = new SecureLS({encodingType: 'aes'});
                    var ruid = ruid.get('ruid').data;
                    var rtoken = new SecureLS({encodingType: 'aes'});
                    var rtoken = rtoken.get('rtoken').data;
                    var ruid_decode = vm.idDecode(ruid);
                    var formInput = {
                            user: ruid_decode,
                            token: rtoken,
                            newPassword: vm.model.password
                    };
                    // Iniciamos el envío de la mutación
                    this.$apollo.mutate({
                        mutation: SET_PASSWORD,
                        variables : {
                            input : formInput
                        }
                    }).then((data) => {
                        vm.isSending = false;
                        if(data.data.setPassword.errors.length > 0)
                        {
                            vm.onError('Ha ocurrido un error, solicita la recuperación de nuevo');
                        }
                        else{
                            vm.onSuccess();
                        }
                        
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.onError('Ha ocurrido un error, inténtalo de nuevo');
                    });
                }
            })
        }
        },
        data() {
        return {
            isSending: false,
            fullPage: false,
            model: {
                password: '',
                confirmPassword: ''
            },
            modelValidations: {
                password: {
                    required: true,
                    min: 8
                },
                confirmPassword: {
                    required: true,
                    confirmed: 'password'
                },
            },
        }
        },
        beforeCreate(){

        },
        beforeDestroy() {
            var ruid = new SecureLS({encodingType: 'aes'});
            ruid.remove('ruid');
            var rtoken = new SecureLS({encodingType: 'aes'});
            rtoken.remove('rtoken');
            this.closeMenu();
        }
    }
</script>
<style>
</style>
